export default "__VITE_ASSET__3SPy71en__"